import React, { Component } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  overflow-y: hidden;
  overflow-x: scroll;
  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    opacity: 0;
    display: none;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: transparent;
    outline: 1px solid transparent;
    border-radius: 3px;
  }
`
const ScrollArea = styled.div`
  width: ${props =>
    props.numberOfItems ? props.itemWidth * props.numberOfItems + props.numberOfItems * 10 + 'px' : '100%'};
  min-width: ${props =>
    props.numberOfItems ? props.itemWidth * props.numberOfItems + props.numberOfItems * 10 + 'px' : '100%'};
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  & > * {
    width: ${props => props.itemWidth}px !important;
    max-width: ${props => props.itemWidth}px !important;
    margin: ${props => (props.margin ? props.margin : '10px 5px')};
    display: inline-block;
  }
`
class CustomSlider extends Component {
  state = {}
  render() {
    const { itemWidth, numberOfItems, children, margin } = this.props
    return (
      <Wrapper>
        <ScrollArea itemWidth={itemWidth} numberOfItems={numberOfItems} margin={margin}>
          {children}
        </ScrollArea>
      </Wrapper>
    )
  }
}

export default CustomSlider



// WEBPACK FOOTER //
// ./src/components/CustomSlider.js